import { render, staticRenderFns } from "./ArrowButton.vue?vue&type=template&id=4b72b3b5&scoped=true"
import script from "./ArrowButton.vue?vue&type=script&lang=ts"
export * from "./ArrowButton.vue?vue&type=script&lang=ts"
import style0 from "./ArrowButton.vue?vue&type=style&index=0&id=4b72b3b5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b72b3b5",
  null
  
)

export default component.exports